import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProcessingTimeoutInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const ProcessingTimeoutInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  options.push({ text: `0 seconds`, value: '0' });
  options.push({ text: `1 second`, value: '1' });

  for (let i = 2; i <= 10; i += 0.5) {
    options.push({ text: `${i} seconds`, value: i.toString() });
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          aggregatorProcessingTimeout: parseFloat(option.value),
        });
      } else {
        updateEncoder(project.encoder, {
          aggregatorProcessingTimeout: parseFloat(option.value),
        });
      }
    }
  };

  return (
    <div className="processing-timeout-input">
      <div className="input-title">
        {t('producer.inputs.processing-timeout.title')}
        <Help
          title="Flush Text on Timeout"
          text="Flush Text on Timeout ensures that any captions currently buffered are sent if no new text is received within the specified time.<br/><br/>- This prevents captions from being stuck or delayed when there is a pause in the incoming text.<br/>- Adjust the timeout duration based on the pacing of your content to maintain smooth caption flow.<br/><br/>Useful for keeping captions up-to-date even during brief gaps in speech or input."
        />
      </div>
      <Dropdown
        value={project.encoder.aggregatorProcessingTimeout.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.processing-timeout.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.processing-timeout.footer')}</div>
    </div>
  );
};

export default React.memo(ProcessingTimeoutInput);
